import React from "react";

import svg from "../../assets/images/icons/steps/Log Message f.svg";

export const LogStepIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Log Step"}
    />
);
